import AddIcon from "@mui/icons-material/Add";
import SearchIcon from "@mui/icons-material/Search";
import type {UseEntityData} from "crqlar-react-common/dist/components/useEntity";
import type {AsaConfig} from "crqlar-react-common/dist/models/integrations/asa/asa.config";
import {AsaTaskService} from "crqlar-react-common/dist/services/integrations/asa/asaTask.service";
import {useState} from "react";
import {useTranslation} from "react-i18next";
import SyncTasksTable from "../../common/SyncTasksTable";
import CheckAvailabilityDialog from "./CheckAvailabilityDialog";

interface Props {
    configData: UseEntityData<AsaConfig>
}

const AsaTasks = ({configData}: Props) => {
    const {t} = useTranslation();
    const [checkAvailabilityOpen, setCheckAvailabilityOpen] = useState(false);
    const config = configData.item;

    return (
        <>
            <SyncTasksTable
                configId={config.id}
                tableId="system-asa-sync-tasks"
                list={AsaTaskService.getAll}
                actions={[
                    {
                        id: 'btn-check-service-availability',
                        label: t('Availability'),
                        startIcon: <SearchIcon/>,
                        onClick: () => setCheckAvailabilityOpen(true),
                        refreshAfter: false
                    },
                    {
                        id: 'btn-schedule-full-sync',
                        label: t('Full sync'),
                        startIcon: <AddIcon/>,
                        onClick: () => AsaTaskService.scheduleFullSync(config.id!)
                    }
                ]}
            />

            <CheckAvailabilityDialog
                open={checkAvailabilityOpen}
                onClose={() => setCheckAvailabilityOpen(false)}
                asaCredentials={config.credentials!!}
                spaSectorId={config.dataProcessingRules?.spaSectorId}
            />
        </>
    );
};

export default AsaTasks;
